import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=4c49f899&scoped=true"
import script from "./dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./dialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./dialog.vue?vue&type=style&index=0&id=4c49f899&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c49f899",
  null
  
)

export default component.exports